/* Reflexstrip — theme behaviour.
   No dependencies. Progressive enhancement only: every surface stays usable
   with JavaScript disabled. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  /* --- Mobile navigation panel ------------------------------------------ */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var panel = document.querySelector('[data-mobile-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      var icon = toggle.querySelector('[data-icon-open]');
      var closeIcon = toggle.querySelector('[data-icon-close]');
      if (icon) icon.hidden = !open;
      if (closeIcon) closeIcon.hidden = open;
    });
  }

  /* --- Navigation disclosure menus --------------------------------------
     Every top-level group may expose more than one control for the same
     menu (a label button plus a separate caret), so all controls inside the
     item are bound and share the open state. */
  function initNavMenus() {
    var items = document.querySelectorAll('[data-nav-item]');
    Array.prototype.forEach.call(items, function (item) {
      var carets = item.querySelectorAll('[data-nav-caret]');
      var menu = item.querySelector('[data-nav-menu]');
      if (!carets.length || !menu) return;

      function setOpen(open) {
        Array.prototype.forEach.call(carets, function (caret) {
          caret.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        menu.hidden = !open;
      }

      Array.prototype.forEach.call(carets, function (caret) {
        caret.addEventListener('click', function (event) {
          event.preventDefault();
          setOpen(caret.getAttribute('aria-expanded') !== 'true');
        });
      });

      item.addEventListener('mouseenter', function () {
        setOpen(true);
      });

      item.addEventListener('mouseleave', function () {
        setOpen(false);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          setOpen(false);
        }
      });
    });
  }

  /* --- Catalogue filter chips (client-side only, no cart or pricing) ---- */
  function initCatalogFilters() {
    var groups = document.querySelectorAll('[data-filter-group]');
    Array.prototype.forEach.call(groups, function (group) {
      var buttons = group.querySelectorAll('[data-filter-value]');
      var root = document.querySelector('[data-catalog-root]');
      if (!buttons.length || !root) return;

      var cards = root.querySelectorAll('[data-line]');
      var empty = document.querySelector('[data-catalog-empty]');

      function apply(value) {
        var visible = 0;
        Array.prototype.forEach.call(cards, function (card) {
          var match = value === 'all' || card.getAttribute('data-line') === value;
          card.hidden = !match;
          if (match) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      }

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          Array.prototype.forEach.call(buttons, function (other) {
            other.classList.remove('is-active');
            other.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          apply(button.getAttribute('data-filter-value'));
        });
      });
    });
  }

  /* --- Product media gallery thumbnails -------------------------------- */
  function initGallery() {
    var galleries = document.querySelectorAll('[data-gallery]');
    Array.prototype.forEach.call(galleries, function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-gallery-thumb');
          var alt = thumb.getAttribute('data-gallery-alt') || '';
          if (!src) return;
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
          Array.prototype.forEach.call(thumbs, function (other) {
            other.setAttribute('aria-current', 'false');
          });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* --- Language dropdown ------------------------------------------------
     The disclosure is a native <details>, so it already opens, closes and
     submits without JavaScript. This only adds accurate aria-expanded,
     Escape-to-close, arrow-key navigation and outside-click close. */
  function initLangDropdown() {
    var dropdowns = document.querySelectorAll('[data-lang-dropdown]');

    Array.prototype.forEach.call(dropdowns, function (dropdown) {
      var summary = dropdown.querySelector('summary');
      var menu = dropdown.querySelector('[data-lang-menu]');
      if (!summary) return;

      function setExpanded(open) {
        summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function close() {
        dropdown.open = false;
        setExpanded(false);
      }

      function options() {
        if (!menu) return [];
        return Array.prototype.slice.call(menu.querySelectorAll('.lang-option'));
      }

      /* Viewport collision handling. The CSS anchor already keeps the menu on
         screen when the panel footer is the containing block; this clamps the
         remaining edge cases (very short viewports, rotated devices) and caps
         the height to the space actually available below the summary. */
      function clamp() {
        if (!menu || !dropdown.open) return;

        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var gutter = 12;
        var summaryRect = summary.getBoundingClientRect();

        menu.style.setProperty(
          '--accio-lang-menu-max',
          Math.max(180, Math.round(viewportHeight - summaryRect.bottom - gutter * 2)) + 'px'
        );

        menu.style.setProperty('--accio-lang-menu-shift', '0px');

        var menuRect = menu.getBoundingClientRect();
        var shift = 0;

        if (menuRect.left < gutter) {
          shift = gutter - menuRect.left;
        } else if (menuRect.right > viewportWidth - gutter) {
          shift = viewportWidth - gutter - menuRect.right;
        }

        if (shift !== 0) {
          menu.style.setProperty('--accio-lang-menu-shift', Math.round(shift) + 'px');
        }
      }

      setExpanded(dropdown.open);

      dropdown.addEventListener('toggle', function () {
        setExpanded(dropdown.open);
        if (dropdown.open) {
          clamp();
          var list = options();
          var active = list.filter(function (option) {
            return option.classList.contains('is-active');
          })[0];
          if (active) active.focus();
        }
      });

      window.addEventListener('resize', clamp);
      window.addEventListener('scroll', clamp, { passive: true });

      dropdown.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && dropdown.open) {
          event.preventDefault();
          close();
          summary.focus();
          return;
        }

        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

        var list = options();
        if (!list.length) return;

        event.preventDefault();
        var index = list.indexOf(document.activeElement);
        var next;

        if (event.key === 'ArrowDown') {
          next = index < 0 ? 0 : Math.min(index + 1, list.length - 1);
        } else {
          next = index <= 0 ? list.length - 1 : index - 1;
        }

        list[next].focus();
      });

      document.addEventListener('click', function (event) {
        if (!dropdown.open) return;
        if (dropdown.contains(event.target)) return;
        close();
      });
    });
  }

  /* --- Language change announcement ------------------------------------ */
  function initLanguageAnnouncer() {
    var announcer = document.querySelector('[data-lang-announcer]');
    if (!announcer) return;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var option = target.closest('.lang-option');
      if (!option) return;
      var label = option.getAttribute('data-lang-label');
      if (label) announcer.textContent = label;
    });
  }

  /* --- Header search panel ----------------------------------------------
     The toggle reveals a panel holding a plain GET form to the storefront
     search, scoped to products. The form itself needs no JavaScript; without
     JavaScript the panel stays closed and every other surface is unchanged. */
  function initHeaderSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-header-search]');
    if (!toggle || !panel) return;

    var input = panel.querySelector('[data-search-input]');

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (open && input) input.focus();
    }

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';

      /* Only one header panel stays open at a time. */
      if (!open) {
        var navToggle = document.querySelector('[data-nav-toggle]');
        if (navToggle && navToggle.getAttribute('aria-expanded') === 'true') navToggle.click();
      }

      setOpen(!open);
    });

    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      setOpen(false);
      toggle.focus();
    });

    document.addEventListener('click', function (event) {
      if (panel.hidden) return;
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      setOpen(false);
    });
  }

  ready(function () {
    initMobileNav();
    initNavMenus();
    initCatalogFilters();
    initGallery();
    initLangDropdown();
    initLanguageAnnouncer();
    initHeaderSearch();
  });
})();
